import { Badge, BadgeType } from '@@/Badge';

import { toTitleCase } from './utils';

export const SEVERITY_LEVELS = [
  'TRACE',
  'DEBUG',
  'INFO',
  'WARNING',
  'ERROR',
  'FATAL',
] as const;

type SeverityLevel = (typeof SEVERITY_LEVELS)[number];

const SEVERITY_BADGE_TYPES: Record<SeverityLevel, BadgeType> = {
  TRACE: 'muted',
  DEBUG: 'muted',
  INFO: 'success',
  WARNING: 'warn',
  ERROR: 'danger',
  FATAL: 'danger',
};

export function SeverityPill({ severity }: { severity: string }) {
  return (
    <Badge type={badgeType(severity)} size="md">
      {toTitleCase(severity)}
    </Badge>
  );
}

function badgeType(severity: string): BadgeType {
  const upper = severity.toUpperCase();
  const level = SEVERITY_LEVELS.find((l) => l === upper);
  return level ? SEVERITY_BADGE_TYPES[level] : 'muted';
}
